export default function userDetail({
  nullGroupIdentifier,
  currentGroupName,
}) {
  return {
    updateGroup() {
      const select = event.target;
      const { value } = select;
      const selected = select.querySelector(`[value="${value}"]`);
      const newGroupName = selected.innerText.trim();
      const form = document.getElementById('group-form');
      const question = (
        value == nullGroupIdentifier // deliberate loose equality
        ? `Remove user from group '${currentGroupName}'`
        : `Reassign user to group '${newGroupName}'`
      );
      window.confirmationModal.ask(question, () => form.submit(), () => form.reset());
    },
  };
}
